import React, { useEffect, useState } from "react";
import { CardBody, Card, Input, Label, Form, Button } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { translateApiError } from "../../helpers/translateApiError";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../components/Common/Loader";

// action
import { registerUser, apiError, resetRegisterFlag } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useHistory, useParams } from "react-router-dom";

import AuthPageLayout from "../../layouts/VerticalLayouts/AuthPageLayout";

const SignUp = (props) => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", { page: t("auth.signUp.pageTitle") });

  // password registry validation
  const [invalidLength, setInvalidLength] = useState(true);
  const [missingNumber, setMissingNumber] = useState(true);
  const [missingLetter, setMissingLetter] = useState(true);

  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
      rememberMe: false,
      // confirm_password: "",
    },
    // validateOnChange: false,
    // validateOnBlur: false,
    validationSchema: Yup.object({
      email: Yup.string()
        .matches(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          t("auth.validation.invalidEmail")
        )
        .required(t("auth.validation.enterEmail")),
      // TODO - check if email is taken once response is received from the server

      password: Yup.string()
        .required(t("auth.validation.enterPassword"))
        .test("num", "dummy msg", (val) => {
          let numberRegex = new RegExp(".*[0-9].*");
          if (numberRegex.test(val)) {
            setMissingNumber(false);
          } else {
            setMissingNumber(true);
          }
          return numberRegex.test(val);
        })
        .test("letter", "dummy msg", (val) => {
          let letterRegex = new RegExp("[a-zA-Z]");
          if (letterRegex.test(val)) {
            setMissingLetter(false);
          } else {
            setMissingLetter(true);
          }
          return letterRegex.test(val);
        })
        .test("len", "dummy msg", (val) => {
          let lengthRegex = new RegExp("[0-9a-zA-Z]{8,}");
          if (lengthRegex.test(val)) {
            setInvalidLength(false);
          } else {
            setInvalidLength(true);
          }
          return lengthRegex.test(val);
        }),
      rememberMe: Yup.boolean(),
    }),

    onSubmit: (values) => {
      dispatch(
        registerUser(
          {
            token: params.token,
            emailAddress: values.email,
            password: values.password,
            rememberMe: values.rememberMe,
          },
          props.history
        )
      );
    },
  });

  const { registrationError, success, loading, errorCount } = useSelector(
    (state) => ({
      registrationError: state.Account.registrationError,
      success: state.Account.success,
      loading: state.Account.loading,
      errorCount: state.Account.errorCount,
    })
  );

  useEffect(() => {
    dispatch(apiError(""));
  }, [dispatch]);

  // Show error toast when error changes
  useEffect(() => {
    if (registrationError && errorCount > 0) {
      // Extract error message from various possible error formats
      let errorMessage = t("auth.signUp.error");

      if (typeof registrationError === "string") {
        errorMessage = translateApiError(registrationError);
      } else if (registrationError.message) {
        errorMessage = translateApiError(registrationError);
      } else if (registrationError.error) {
        errorMessage = translateApiError(registrationError.error);
      }

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Reset the error after showing toast
      setTimeout(() => {
        dispatch(resetRegisterFlag());
      }, 100);
    }
  }, [errorCount, dispatch]);

  // Show success toast and redirect
  useEffect(() => {
    if (success) {
      toast.success(t("auth.signUp.success"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setTimeout(() => {
        history.push("/login");
      }, 3000);

      setTimeout(() => {
        dispatch(resetRegisterFlag());
      }, 3000);
    }
  }, [dispatch, success, history]);

  // to-do refactor this
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <React.Fragment>
      <AuthPageLayout>
        <ToastContainer />
        <Card className="mt-4">
          <CardBody
            style={{
              paddingTop: "28px",
              paddingBottom: "28px",
              paddingLeft: "24px",
              paddingRight: "24px",
            }}
          >
            <div className="mb-4">
              <h3 className="text-primary fw-semibold mb-2 auth-form-heading">
                {t("auth.signUp.heading")}
              </h3>
              <p className="text-muted mb-0 auth-form-subheading">
                {t("auth.signUp.subheading")}
              </p>
            </div>

            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className="mb-3">
                <Label
                  htmlFor="email"
                  className="form-label fw-semibold auth-form-label"
                >
                  {t("common.labels.email")}
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  id="email"
                  name="email"
                  className="form-control auth-form-input"
                  placeholder={t("auth.fields.emailPlaceholder")}
                  type="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email || ""}
                  invalid={
                    validation.touched.email && validation.errors.email
                      ? true
                      : false
                  }
                />
                {validation.touched.email && validation.errors.email ? (
                  <div className="text-danger mt-1 auth-form-error">
                    {validation.errors.email}
                  </div>
                ) : null}
              </div>

              <div className="mb-4">
                <Label
                  htmlFor="password"
                  className="form-label fw-semibold auth-form-label"
                >
                  {t("auth.fields.password")}
                  <span className="text-danger">*</span>
                </Label>
                <div className="position-relative auth-pass-inputgroup">
                  <Input
                    data-id="password"
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    className="form-control pe-5 auth-form-input"
                    placeholder={t("auth.fields.passwordPlaceholder")}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.password || ""}
                    invalid={
                      validation.touched.password && validation.errors.password
                        ? true
                        : false
                    }
                  />
                  <button
                    className={
                      "btn btn-link position-absolute end-0 top-0 text-decoration-none text-dark " +
                      (validation.errors.password && "has-error")
                    }
                    type="button"
                    id="password-addon"
                    onClick={togglePassword}
                  >
                    <i className="ri-eye-fill align-middle"></i>
                  </button>
                </div>
                {validation.touched.password &&
                validation.errors.password &&
                validation.values.password ? (
                  <div className="text-danger mt-1 auth-form-error">
                    <p className="mb-1">{t("auth.passwordRules.title")}</p>
                    <ul
                      className="mb-0"
                      style={{ paddingLeft: "20px", fontSize: "12px" }}
                    >
                      <li className={missingNumber ? "" : "text-success"}>
                        {t("auth.passwordRules.number")}
                      </li>
                      <li className={missingLetter ? "" : "text-success"}>
                        {t("auth.passwordRules.letter")}
                      </li>
                      <li className={invalidLength ? "" : "text-success"}>
                        {t("auth.passwordRules.length")}
                      </li>
                    </ul>
                  </div>
                ) : null}
              </div>

              <div className="mb-3">
                <Button
                  color="primary"
                  type="submit"
                  className="w-100 fw-semibold auth-form-button"
                  disabled={loading}
                >
                  {loading ? (
                    <Loader size="sm"></Loader>
                  ) : (
                    t("auth.signUp.submit")
                  )}
                </Button>
              </div>

              {/* Sign in link */}
              <div className="text-center">
                <span className="text-dark auth-form-footer-text">
                  {t("auth.links.alreadyHaveAccount")}
                </span>
                <Link
                  to="/login"
                  className="text-primary text-decoration-underline auth-form-footer-text"
                >
                  {t("auth.actions.signIn")}
                </Link>
              </div>
            </Form>
          </CardBody>
        </Card>
      </AuthPageLayout>
    </React.Fragment>
  );
};

export default SignUp;
